import { RegistrationForm } from "./RegistrationForm/RegistrationForm";
import { OTPForm } from "./OTPForm/OTPForm";
import { PinGenSection } from "./PinGenSection/PinGenSection";
import { WelcomeSection } from "./WelcomeSection/WelcomeSection";
import { useState } from "react";

export const HomePage = () => {
  const [registrationStep,setRegistrationStep] = useState(0)
  const [userData,setUserData] = useState(null);
  const [authToken,setAuthToken] = useState(null);
  console.log("user data token",authToken)
  return (
    <>
    {
      registrationStep ==0 && <RegistrationForm setUserData={setUserData} setRegistrationStep={setRegistrationStep}/>
    }
      {
      registrationStep ==1 && <OTPForm setAuthToken={setAuthToken} userData={userData} isRegisterationTrue={true} setRegistrationStep={setRegistrationStep}/>
    }
      {
      registrationStep ==2 && <PinGenSection authToken={authToken} userData={userData}  isRegisterationTrue={true} setRegistrationStep={setRegistrationStep}/>
    }
      {
      registrationStep ==3 && <WelcomeSection isRegisterationTrue={true}/>
    }

    </>
  );
};
